import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function getStatusColor(status) {
  const colors = {
    PENDENTE: 'bg-orange-100 text-orange-700',
    CONFIRMADO: 'bg-blue-100 text-blue-700',
    PREPARO: 'bg-purple-100 text-purple-700',
    PRONTO: 'bg-cyan-100 text-cyan-700',
    SAIU: 'bg-indigo-100 text-indigo-700',
    ENTREGUE: 'bg-emerald-100 text-emerald-700',
    CANCELADO: 'bg-red-100 text-red-700',
  };
  return colors[status] || 'bg-slate-100 text-slate-600';
}

export function getStatusLabel(status) {
  const labels = {
    PENDENTE: 'Pendente',
    CONFIRMADO: 'Confirmado',
    PREPARO: 'Em Preparo',
    PRONTO: 'Pronto',
    SAIU: 'Saiu p/ Entrega',
    ENTREGUE: 'Entregue',
    CANCELADO: 'Cancelado',
  };
  return labels[status] || status;
}
